import {GET, PATCH, POST, PUT, DELETE} from '../constants/API_CONSTANTS';
import {
  GET_LOCATION_SETTINGS_DATA,
  POST_LOCATION_SETTINGS_DATA,
  UPDATE_LOCATION_SETTINGS_DATA,
  PAUSE_LOCATION,
  UNPAUSE_LOCATION,
  GET_LOCATION_SETTINGS_DATA_BY_ID,
  GET_CALLING_PHONE,
  PUBLISH_LOCATION,
  UPDATE_LOCATION_ACCOUNT_TEMPLATE,
  UPDATE_FEEDBACK_SETTINGS,
  UPDATE_FEEDBACK_BANNER_STATUS,
  CREATE_STORE_HOLIDAYS,
  GET_SELF_DELIVERY_REPORT_EMAIL,
  UPDATE_SELF_DELIVERY_REPORT_EMAIL,
  GET_SUCCESS_MANAGER,
  GET_SPECIAL_HOURS,
  CREATE_SPECIAL_HOURS,
  DELETE_SPECIAL_HOURS
} from '../constants/LOCATION_SETTINGS_API_ENDPOINTS';
import {request} from '../utils/request';
import {TASK_TYPE_SETTINGS_DATA_UPDATE} from '../../../store/global/globalNotifications/constants';

export const getLocationSettingsDataApi = async () => {
  return request(GET, GET_LOCATION_SETTINGS_DATA());
};

export const getLocationSettingsDataByIdApi = async (id) => {
  return request(GET, GET_LOCATION_SETTINGS_DATA_BY_ID(id));
};

export const updateLocationSettingsDataApi = async (id, data) => {
  return request(PUT, UPDATE_LOCATION_SETTINGS_DATA(id), {data});
};

export const pauseLocationApi = async (id, data) => {
  return request(POST, PAUSE_LOCATION(id), {data});
};

export const unpauseLocationApi = async (id, data) => {
  return request(POST, UNPAUSE_LOCATION(id), {data});
};

export const postLocationSettingsDataApi = async (data) => {
  return request(POST, POST_LOCATION_SETTINGS_DATA(), {data});
};

export const getCallingPhoneApi = async (countryCode) => {
  return request(GET, GET_CALLING_PHONE(countryCode));
};

export const publishLocationAPi = async (menuConfigId) => {
  return request(
    POST,
    PUBLISH_LOCATION(menuConfigId),
    {},
    {headers: {'Sync-Type': TASK_TYPE_SETTINGS_DATA_UPDATE}}
  );
};

export const updateTemplateLocationApi = async (id, data) => {
  return request(PATCH, UPDATE_LOCATION_ACCOUNT_TEMPLATE(id), {data});
};

export const updateFeedbackSettingsApi = async (id, data) => {
  return request(PATCH, UPDATE_FEEDBACK_SETTINGS(id), {data});
};

export const updateFeedbackBannerStatusApi = async (id, data) => {
  return request(PATCH, UPDATE_FEEDBACK_BANNER_STATUS(id), {data});
};

export const createStoreHolidaysApi = async (id, data) => {
  return request(POST, CREATE_STORE_HOLIDAYS(id), {data});
};

export const getSelfDeliveryReportEmailApi = async (locationId) => {
  return request(GET, GET_SELF_DELIVERY_REPORT_EMAIL(locationId));
};

export const updateSelfDeliveryReportEmailApi = async (locationId, data) => {
  return request(PUT, UPDATE_SELF_DELIVERY_REPORT_EMAIL(locationId), {data});
};

export const getSuccessManagerApi = async (locationId) => {
  // The CSM is optional, so a failed load hides it instead of showing a toast.
  return request(GET, GET_SUCCESS_MANAGER(locationId), null, {silent: true});
};

export const getSpecialHoursApi = async (id) => {
  return request(GET, GET_SPECIAL_HOURS(id));
};

export const createSpecialHoursApi = async (id, data) => {
  return request(POST, CREATE_SPECIAL_HOURS(id), {data});
};

export const deleteSpecialHoursApi = async (locationId, specialHoursId) => {
  return request(DELETE, DELETE_SPECIAL_HOURS(locationId, specialHoursId));
};
